export default __webpack_public_path__ + "static/media/piratengp24_dark.ec144ec1.png";